import { render, staticRenderFns } from "./RemoveVpcDialog.vue?vue&type=template&id=255c461c"
import script from "./RemoveVpcDialog.vue?vue&type=script&lang=js"
export * from "./RemoveVpcDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports